module.exports = new __parcel__URL__("hounds-of-love.1fb3b811.jpg").toString();